// extracted by mini-css-extract-plugin
module.exports = {"status":"table_status__z4hg_"};